import React from 'react';
import PropTypes from 'prop-types';
import styles from './Input.less';

const emptyFn = () => {};

export default class Input extends React.Component {
  render() {
    const {
      inputInfoText,
      text,
      type,
      onChange,
      maxNumber,
      minNumber,
      value,
      onFocus,
      additionalClass,
      placeholder,
    } = this.props;
    const inputDivClass = inputInfoText
      ? [styles.inputDiv, styles.inputInfoText, additionalClass].join(' ')
      : [styles.inputDiv, additionalClass].join(' ');
    return (
      <div data-info-text={inputInfoText} className={inputDivClass}>
        <span className={styles.inputHeading}>{text}</span>
        <input
          className="input-text"
          type={type}
          name={text}
          placeholder={placeholder}
          onInput={onChange}
          max={maxNumber && maxNumber.toString()}
          min={minNumber && minNumber.toString()}
          value={value}
          onFocus={onFocus}
          onChange={emptyFn} // suppress wrong warning (https://github.com/facebook/react/issues/1118)
        />
      </div>
    );
  }
}

Input.defaultProps = {
  inputInfoText: '',
  type: 'text',
  onChange: null,
  maxNumber: null,
  minNumber: null,
  value: '',
  onFocus: null,
  additionalClass: '',
  placeholder: '',
};

Input.propTypes = {
  text: PropTypes.string.isRequired,
  inputInfoText: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['text', 'number']),
  maxNumber: PropTypes.number,
  minNumber: PropTypes.number,
  value: PropTypes.string,
  onFocus: PropTypes.func,
  additionalClass: PropTypes.string,
  placeholder: PropTypes.string,
};
